<template>
  <OTCSidebar
    :dialog="PublishDialog"
    :methods="methods"
    store-module="emailBuilder"
  />
</template>

<script lang="ts" setup>
import OTCSidebar from '../../../components/otc/otc-sidebar/OTCSidebar.vue'
import { methods } from '../methods'

import PublishDialog from './PublishDialog.vue'
</script>
